// extracted by mini-css-extract-plugin
export default {"status":"TableServicesMethod_status__N+Ya6","advance":"TableServicesMethod_advance__pyyeF","walk-in":"TableServicesMethod_walk-in__9tHV3"};